import { createStore } from 'vuex'
import authStore from './login'
import historyStore from './history'

export default createStore({
  namespaced: true,
  modules: {
    auth: authStore,
    history: historyStore
  }
})
